import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsBuyerCostsStep2FormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';

export const useCalculatorBuyerCostsStep2FormFields = (intl: IntlShape) => {
  const calculatorBuyerCostsStep2FormFields: Record<
    keyof CalculatorsBuyerCostsStep2FormFields,
    FormInput
  > = {
    applicantAgeUnder35: {
      fieldName: 'applicantAgeUnder35',
      label: intl.formatMessage({
        id: 'step2.applicantAgeUnder35',
        defaultMessage: 'Ben je jonger dan 35 jaar?'
      }),
      type: 'radio',
      options: [
        { label: intl.formatMessage({ id: 'shared.yes', defaultMessage: 'ja' }), value: 'true' },
        { label: intl.formatMessage({ id: 'shared.no', defaultMessage: 'nee' }), value: 'false' }
      ],
      defaultValue: getDefaultValue('false', true)
    },
    applicantTransferTaxExemptionUsed: {
      fieldName: 'applicantTransferTaxExemptionUsed',
      label: intl.formatMessage({
        id: 'step2.applicantTransferTaxExemptionUsed',
        defaultMessage:
          'Heb je al eerder gebruik gemaakt van de regeling om vrijgesteld te worden van overdrachtsbelasting?'
      }),
      type: 'radio',
      options: [
        { label: intl.formatMessage({ id: 'shared.yes', defaultMessage: 'ja' }), value: 'true' },
        { label: intl.formatMessage({ id: 'shared.no', defaultMessage: 'nee' }), value: 'false' }
      ],
      defaultValue: getDefaultValue('false', true)
    },
    partnerAgeUnder35: {
      fieldName: 'partnerAgeUnder35',
      label: 'Is je partner jonger dan 35 jaar?',
      type: 'radio',
      options: [
        { label: intl.formatMessage({ id: 'shared.yes', defaultMessage: 'ja' }), value: 'true' },
        { label: intl.formatMessage({ id: 'shared.no', defaultMessage: 'nee' }), value: 'false' }
      ],
      defaultValue: getDefaultValue('false', true)
    },
    partnerTransferTaxExemptionUsed: {
      fieldName: 'partnerTransferTaxExemptionUsed',
      label: intl.formatMessage({
        id: 'step2.partnerTransferTaxExemptionUsed',
        defaultMessage:
          'Heeft je partner al eerder gebruik gemaakt van de regeling om vrijgesteld te worden van overdrachtsbelasting?'
      }),
      type: 'radio',
      options: [
        { label: intl.formatMessage({ id: 'shared.yes', defaultMessage: 'ja' }), value: 'true' },
        { label: intl.formatMessage({ id: 'shared.no', defaultMessage: 'nee' }), value: 'false' }
      ],
      defaultValue: getDefaultValue('false', true)
    },
    willLiveInProperty: {
      fieldName: 'willLiveInProperty',
      label: '',
      type: 'radio',
      tooltip: intl.formatMessage({
        id: 'step2.willLiveInProperty.tooltip',
        defaultMessage:
          'De overdrachtsbelasting is hoger als het gaat om een recreatiewoning of een beleggingspand koopt'
      }),
      options: [
        { label: intl.formatMessage({ id: 'shared.yes', defaultMessage: 'ja' }), value: 'true' },
        { label: intl.formatMessage({ id: 'shared.no', defaultMessage: 'nee' }), value: 'false' }
      ],
      defaultValue: getDefaultValue('true', true)
    }
  };
  return calculatorBuyerCostsStep2FormFields;
};
